var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ResourceView',{attrs:{"entityId":_vm.$route.params.machineId,"entityClass":"Machine","defaultEmailTemplate":_vm.defaultEmailTemplate}})}
var staticRenderFns = []

export { render, staticRenderFns }